import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type CustomAccordionProps = {
  title: string;
  content: string | React.ReactNode;
  defaultExpanded?: boolean;
  isLast?: boolean;
};

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  content,
  defaultExpanded = false,
  isLast = false,
}) => {
  return (
    <Accordion
      className={`rounded-none border-x-0 border-t-0 ${!isLast ? 'border-bottom' : 'border-b-0'}`}
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummary
        className="px-1 md:px-6"
        expandIcon={<ExpandMoreIcon color="primary" />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
        sx={{ borderRadius: '0px !important' }}
      >
        <Typography variant="s1">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className="px-1 md:px-6 pt-0">{content}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
